import { BaseDto } from './BaseDto';
/** Connection from one node to another
 * 
 *  - Identifier is the Identifier of the parent node
 *  - Name is the name of the object that triggers this connection
 *  - Value (if present) is the value of the object that triggers this connection
 */
export class NodeConnection extends BaseDto {
    public Value:any;
    constructor(identifier:string, name:string, value:any){
        super();
        this.Identifier = identifier;
        this.Name = name;
        this.Value = value;
    }
}

export class NodeConnectionNames {
    public static readonly ALWAYS_TRIGGERED = "Always";
    public static readonly UNNAMED_VALUE = "_noName";
    public static readonly ALREADY_PROCESSED = "_alreadyProcessed";
    public static readonly RESULT = "Result";
    public static readonly ERROR = "Error";
    public static readonly CLICKED = "Clicked";
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/dto/NodeConnection.ts